import template from './bf-filter-panel.html.twig';
import './bf-filter-panel.scss';
const {Component} = Shopware;


Component.extend('bf-filter-panel', 'sw-filter-panel', {
    template,
});
